export default __webpack_public_path__ + "static/media/wifiIcon.9e21c41b.svg";